/** USD spot-price lookup, as returned by `useOraclePrices().getUsdPrice`. */
export type GetUsdPrice = (mint: string | undefined | null) => number | undefined;

export enum TransactionType {
    AMMBuy = 0,
    AmmSell = 1,
    EnglishAuction = 2,
    OTC = 3,
    DutchAuction = 4
}

export enum ExternalPricingSource {
    BAXUS = 0,
    CoinGecko = 1
}

export enum PriceFetchType {
    Spot,
    Twap
}
